import React from 'react';
import { useRouter } from 'next/compat/router';
import { ListPageEntry } from '@dutchiesdk/ecommerce-extensions-sdk';

type UseProductListInjectionsProps = {
  interstitials?: ListPageEntry[];
  slots?: ListPageEntry[];
};

type UseProductListInjectionsReturn = {
  InterstitialComponent: React.ElementType | null;
  SlotComponent: React.ElementType | null;
};

export const useProductListInjections = ({
  interstitials,
  slots,
}: UseProductListInjectionsProps): UseProductListInjectionsReturn => {
  const { isReady, query } = useRouter() ?? {};

  if (!isReady) {
    return { InterstitialComponent: null, SlotComponent: null };
  }

  const { category, slug, page = '1' } = query ?? {};
  const categoryToMatch = (category ?? slug) as string;

  const matchingInterstitial = interstitials ? findMatchingEntry(interstitials, categoryToMatch) : null;
  const matchingSlot = slots ? findMatchingEntry(slots, categoryToMatch) : null;

  if (!matchingInterstitial && !matchingSlot) {
    return { InterstitialComponent: null, SlotComponent: null };
  }

  // Get component for current page (0-indexed, page is 1-indexed)
  const pageIndex = Number(page) - 1;
  const InjectedInterstitial = matchingInterstitial?.components[pageIndex] ?? null;
  const InjectedSlot = matchingSlot?.components[pageIndex] ?? null;

  return { InterstitialComponent: InjectedInterstitial, SlotComponent: InjectedSlot };
};

const findMatchingEntry = (entries: ListPageEntry[], category: string): ListPageEntry | undefined =>
  entries.find((entry) => entry.category === category) ?? entries.find((entry) => entry.category === undefined);
